export default function (el) {
  if (el === null) return false;

  if (window.location.search.includes('utm')) {
    el.addEventListener('click', (e) => {
      e.preventDefault();

      window.open(
        `${el.getAttribute('href')}${window.location.search}`,
        '_self'
      );
    });
  }
}
